<template>
  <div class="pb">
    <p class="note">{{ $t('ARC_PANEL.BADGES.STAGE2_NOTE') }}</p>
    <div v-if="loading" class="muted">{{ $t('ARC_MGMT.LOADING') }}</div>
    <div v-else class="grid">
      <div v-for="b in items" :key="b.id" class="badge" :class="{ locked: !b.conquistada }">
        <div class="medal" :class="b.pilar">{{ b.sigla }}</div>
        <div class="info">
          <b>{{ b.nome }}</b>
          <small v-if="b.conquistada">{{ $t('ARC_PANEL.BADGES.EARNED_ON', { d: (b.conquistada_em || '').slice(0,10) }) }}<template v-if="b.descricao"> · {{ b.descricao }}</template></small>
          <small v-else><span class="lock">🔒</span> {{ b.descricao }}</small>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ArcAPI from 'dashboard/api/arc';
export default {
  data() { return { items: [], loading: true }; },
  mounted() { this.load(); },
  methods: { async load() { this.loading = true; try { const { data } = await ArcAPI.panelBadges(); this.items = data.payload || []; } finally { this.loading = false; } } },
};
</script>
<style lang="scss" scoped>
.muted { color: var(--s-500); }
.note { font-size: var(--font-size-small); color: var(--s-500); background: var(--s-25); border: 1px dashed var(--s-200); border-radius: 10px; padding: 12px 14px; margin-bottom: var(--space-normal); }
.grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: var(--space-small); }
.badge { display: flex; align-items: center; gap: var(--space-normal); background: var(--white); border: 1px solid var(--s-100); border-radius: 12px; padding: var(--space-normal); &.locked { opacity: .75; } }
.medal { width: 48px; height: 48px; border-radius: 50%; display: grid; place-items: center; font-weight: 800; font-size: 15px; color: #fff; flex-shrink: 0; background: var(--s-400); &.A { background: #1E88E5; } &.R { background: #1F9D63; } &.C { background: #7B61FF; } }
.badge.locked .medal { background: var(--s-100); color: var(--s-400); }
.info { display: flex; flex-direction: column; gap: 2px; b { font-size: var(--font-size-small); color: var(--s-900); font-weight: var(--font-weight-medium); } small { font-size: var(--font-size-mini); color: var(--s-500); } .lock { margin-right: 2px; } }
</style>
